import { TimeLogApi } from '../../../api';
import { ICallback } from '../../../commonTypes/hook.types';
import { useContainer } from '../../useContainer';

const useHttpGetUserTimelog = () => {
    const timeLogApi: TimeLogApi = useContainer(TimeLogApi);

    const exec = (body: any, callback: ICallback) => {
        const { exec, abort } = timeLogApi.getUserTimelog({
            query: body,
            onSuccess: res => {
                if (callback.onSuccess) callback.onSuccess(res.body);
            },
            onError: error => {
                if (callback.onError) callback.onError();
                return error;
            },
        });
        exec();
        return abort;
    };
    return { exec };
};

export default useHttpGetUserTimelog;
